import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Logo } from "../brand/Logo";
import { useAuth } from "../../context/AuthContext";
import { useBasket } from "../../context/BasketContext";
import { LayoutDashboard, ShoppingBag, ShoppingCart, Package, User, LogOut, Menu, X } from "lucide-react";

const nav = [
  { to: "/portal", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/portal/catalogue", label: "Trade Catalogue", icon: ShoppingBag },
  { to: "/portal/basket", label: "My Order", icon: ShoppingCart },
  { to: "/portal/orders", label: "Orders", icon: Package },
  { to: "/portal/account", label: "Account", icon: User },
];

export function PortalLayout({ children, title }) {
  const { user, logout } = useAuth();
  const { count } = useBasket();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const doLogout = async () => { await logout(); navigate("/trade/login"); };

  const SidebarContent = () => (
    <>
      <div className="p-6"><Logo className="h-10" /></div>
      <nav className="flex-1 px-3 space-y-1">
        {nav.map((n) => (
          <NavLink
            key={n.to} to={n.to} end={n.end}
            data-testid={`portal-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            onClick={() => setOpen(false)}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors ${
                isActive ? "bg-sambiva-red text-white" : "text-sambiva-charcoal hover:bg-sambiva-cream"
              }`
            }
          >
            <n.icon size={18} /> {n.label}
            {n.label === "My Order" && count > 0 && (
              <span className="ml-auto bg-sambiva-yellow text-sambiva-charcoal text-xs font-bold px-2 py-0.5 rounded-full">{count}</span>
            )}
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-sambiva-charcoal/8">
        <div className="px-4 py-2 text-xs text-sambiva-muted">{user?.company_name}</div>
        <button data-testid="portal-logout" onClick={doLogout} className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-sambiva-charcoal hover:bg-sambiva-cream w-full">
          <LogOut size={18} /> Logout
        </button>
      </div>
    </>
  );

  return (
    <div className="min-h-screen bg-sambiva-cream flex">
      <aside className="hidden lg:flex w-64 bg-white border-r border-sambiva-charcoal/8 flex-col fixed inset-y-0">
        <SidebarContent />
      </aside>

      {open && (
        <div className="lg:hidden fixed inset-0 z-40 flex">
          <div className="w-64 bg-white flex flex-col"><SidebarContent /></div>
          <div className="flex-1 bg-black/40" onClick={() => setOpen(false)} />
        </div>
      )}

      <div className="flex-1 lg:ml-64">
        <header className="bg-white border-b border-sambiva-charcoal/8 px-4 sm:px-8 py-4 flex items-center gap-3 sticky top-0 z-30">
          <button className="lg:hidden" onClick={() => setOpen(true)}><Menu size={24} /></button>
          <h1 className="font-serif text-xl sm:text-2xl text-sambiva-charcoal">{title}</h1>
        </header>
        <div className="p-4 sm:p-8">{children}</div>
      </div>
    </div>
  );
}
